/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import { connect } from "react-redux";
import {
	formatSeconds,
	getIcon,
	getStatusColor,
	noAvatar,
	toMoney,
} from "../../Components/Functions";
import { loggedUser } from "../../Constants/menus";
import { routers } from "../../Constants/routers";
import Api from "../../Server/Api";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { timeToShorts } from "../doctor/secure/Dashboard";
import TimeSummary from "../../Components/TimeSummary";

const properties = [];

const api = new Api();

const UpcomingAppointment = ({}) => {
	const [upcoming, setUpcoming] = React.useState([]);
	

	React.useEffect(() => {
		api
			.get({
				endpoint: `/users/${loggedUser?.username}/appointments/`,
				data: {
					statuses: ["ACCEPTED"],
				},
			})
			.then((res) => {
				if (res?.results?.length > 0) {
					setUpcoming(res?.results?.map((d) => {
						return {
							...d,
							profile:
								loggedUser?.id === d?.specialist
									? d?.patient_info
									: d?.specialist_info,
							data: [
									{
										label: `${(d.time_slots).map(e => { return `<span style="color: #fff;line-height: 1.65;height: 20px;" class="tag is-${getStatusColor(d?.transaction?.status)} is-elevated mr-1 mb-1">${timeToShorts(e)}</span>` }).join("")} <br/>Date & Time `,
										value: d.date_time,
										icon: "calendar",
										render: <TimeSummary {...d} />
									},
									{
										label: "Duration",
										value: formatSeconds(d.duration),
										icon: "clock"
									},
									{
										label: `Fee • <span style="color: #fff;line-height: 1.65;height: 20px;" class="tag is-${getStatusColor(d?.transaction?.status)} is-elevated">${d?.transaction?.status}</span>`,
										value: toMoney(d?.transaction?.amount),
										icon: "credit-card"
									},
							]
						}
					}));
				}

				// initCarousel()
			});
	}, []);

	const profile = {};

	return (
		
			upcoming?.length > 0 && (
				<>
				 <Carousel>
					 {upcoming.map((upcoming) => {
						 return (
							<div className="dashboard-card is-company">
							<div className="pill-carousel mb-5">
								<div className="upcoming-board-bg ">
												  <img
													  src={
														  upcoming?.profile?.background_image ||
														  require("../../assets/images/pexels-jéshoots-238118.jpg")
															  .default
													  }
													  alt="background"
												  />
											  </div>
											  <div
												  className="h-avatar is-big"
												  style={{ marginTop: -100, marginBottom: 25 }}
											  >
												  <img
													  className="avatar"
													  src={upcoming?.profile?.image || noAvatar()}
													  alt=""
													  style={{ border: "4px solid #fff" }}
												  />
												  {(upcoming?.status === "ACCEPTED"  && upcoming?.transaction?.status === "SUCCESS") ? (
													  <a 
													  href={routers.others.video_call(upcoming?.meeting_id)} 
													  className="button icon-button is-circle is-dark-outlined">
													  <span
														  className="icon is-small"
														  dangerouslySetInnerHTML={{
															  __html: getIcon("video"),
														  }}
													  ></span>
												  </a>
												  ):""}
												  
											  </div>
											  <h3 className="dark-inverted">
												  {upcoming?.profile?.title} {upcoming?.profile?.name}
											  </h3>
											  <p>{upcoming?.profile?.role}</p>
											  <div className="description">
												  <p style={{ fontSize: 15, fontWeight: "bold" }} dangerouslySetInnerHTML={{ __html: upcoming?.profile?.header_title }} />
											  </div>
											  <hr
												  style={{
													  marginBottom: 15,
													  height: 1,
													  marginLeft: -30,
													  width: "calc(100% + 60px)",
												  }}
											  />
											  <div
												  className="list-widget list-widget-v3 is-straight p-0"
												  style={{ border: "none", boxShadow: "none" }}
											  >
												  <div className="inner-list" style={{ textAlign: "left" }}>
													  <div className="icon-timeline">
														  {/*Timeline item*/}
														  {(upcoming?.data || []).map((e) => {
															  return (
																  <div className="timeline-item">
																	  <div
																		  className="timeline-icon is-squared"
																		  dangerouslySetInnerHTML={{ __html: getIcon(e.icon) }}
																	  />
																	  <div className="timeline-content">
																		  <p>{e.value}</p>
																		  {e?.render ? e.render : <span dangerouslySetInnerHTML={{ __html: e.label }} />}
																	  </div>
																  </div>
															  );
														  })}
													  </div>
												  </div>
						  
												  <button class={`button h-button is-${getStatusColor(upcoming?.status)} w-100`}>
													  <span>
														  STATUS : <b>{upcoming?.status}</b>
													  </span>
												  </button>
											  </div>
								</div>
								</div>
						 )
					 })}
			
	  </Carousel>
				
				</>
			)) || (
				<div className="dashboard-card is-company">
				<div className="no-messages" style={{ marginTop: "50%" }}>
					<img
						className="light-image"
						src={
							require("../../assets/images/undraw_calendar_re_ki49.svg").default
						}
						alt=""
					/>
					<div className="text mt-5">
						<h3 style={{ fontWeight: "bold", fontSize: 18 }}>No Appointment</h3>
						<p>
							You do not have any upcoming appointment. To book an appointment
							with a specialist, click the button below to search and connect to
							a specialist.
						</p>
						<a
							href={routers.pages.search()}
							target="_blank"
							className="button h-button is-outlined is-primary w-100 mt-5 "
						>
							<span className="icon">
								<i className="fas fa-search"></i>
							</span>
							<span style={{ fontWeight: "bold" }}>FIND A SPECIALIST</span>
						</a>
					</div>
				</div>
				</div>
			
	);
};

const mapStateToProps = (state) => {
	return { upcomingx: state?.dashboard?.upcoming };
};

const mapDispatchToProps = (dispatch) => {
	return {};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(UpcomingAppointment);
